export enum VehicleLogFilterTypeEnum {
  Theft = 1,
  InWorkshop = 2,
  NotPaid = 3,
  NotRentedReadyToWork = 4,
  RentedAndPaid = 5,
  PrePaymentRent = 6
}
